import { render } from "./Battle.vue?vue&type=template&id=2830971b&bindings={\"num\":\"data\",\"myHp\":\"data\",\"turnContinue\":\"data\",\"isEnemyTurn\":\"data\",\"currentDir\":\"data\",\"currentPathForDisplay\":\"data\",\"armsKind\":\"data\",\"armsPosition\":\"data\",\"parentDir\":\"data\",\"linkedDirs\":\"data\",\"nextDirs\":\"data\"}"
import script from "./Battle.vue?vue&type=script&lang=js"
export * from "./Battle.vue?vue&type=script&lang=js"

import "./Battle.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script